<template>
  <v-card
      v-on:mouseover="elevation = 10"
      v-on:mouseleave="elevation = 2"
      :elevation="elevation"
      :height="getHeight"
  >
    <v-row no-gutters>
      <v-col cols="12" :md="getMdPicture">

        <v-img
            :style="{backgroundColor: getBackgroundColor, border: getBorder}"
            eager
            contain
            height="145" :src="getImage"
        >

          <v-img
              v-if="!hasStock"
              eager
              src="@/assets/img/SinStock.png"
          />

          <div
              v-if="getIcon"
              :style="{position: 'absolute', top:'1px',right:'1px'}"
          >
            <v-icon small :color="getIconColor" class="semiTransparent">{{ getIcon }}</v-icon>
          </div>

        </v-img>
      </v-col>

      <v-col cols="12" :md="getMdText">
        <v-card-title class="pt-1 font-oswald">
          <v-clamp autoresize :max-lines="1" :style="{color: getFontColor}">
            {{ product.name.charAt(0).toUpperCase() + product.name.toLowerCase().substring(1)}}
          </v-clamp>
        </v-card-title>
        <v-card-subtitle class="font-raleway" style="height: 60px">
          <v-clamp autoresize :max-lines="2">
            {{ product.description}}
          </v-clamp>
        </v-card-subtitle>

        <v-card-actions class="pt-0">
          <v-chip :style="{color:getFontColor}">${{ getPrice }}</v-chip>
          <v-spacer></v-spacer>
          <!--REMOVE-->
          <v-btn v-if="editQuantity && quantity > 0"
                 fab small outlined
                 color="red"
                 @click="removeProduct(product, category)"
          >
            <v-icon>{{ quantity === 1 ? 'delete' : 'remove' }}</v-icon>
          </v-btn>
          <!--SHOW-->
          <span v-if="quantity > 0" class="px-3">x{{ quantity }}</span>
          <!--ADD-->
          <v-btn v-if="editQuantity"
                 fab small
                 :color="hasStock ? getFontColor : 'red darken--1'" dark
                 @click="addProduct(product, category, order)"
          >
            <v-icon>{{ hasStock ? 'add' : 'dangerous' }}</v-icon>
          </v-btn>
        </v-card-actions>
      </v-col>
    </v-row>

  </v-card>


</template>

<script>

import VClamp from 'vue-clamp'

export default {
  name: "CustomerProductCard",
  components: {
    VClamp
  },
  props: {
    product: Object,
    category: Object,
    quantity: Number,
    order: {type: Number, default: 999},
    stockQuantity: {type: Number, default: 1000},
    editQuantity: {type: Boolean, default: false},
  },
  data() {
    return {
      elevation: 2
    }
  },
  computed: {
    hasStock() {
      return (this.quantity < this.stockQuantity)
    },
    getImage() {
      let imageCategory
      if (this.product.imageCategory) {
        imageCategory = this.product.imageCategory.find(i => i.category === this.category.id)
      }
      return (imageCategory && imageCategory.image) ? imageCategory.image : this.product.image
    },
    getPrice() {
      return this.product.price + (this.category.surcharge ? this.category.surcharge : 0)
    },
    getSize() {
      switch (this.$store.getters.galleryView) {
        case 12:
          return 'LARGE'
        case 6:
          return 'MEDIUM'
        case 4:
          return 'SMALL'
        default:
          return 'SMALL'
      }
    },
    getHeight() {
      switch (this.getSize) {
        case 'LARGE':
          return this.$vuetify.breakpoint.smAndDown ? 290 : 145
        default:
          return 290
      }
    },
    getMdPicture() {
      switch (this.getSize) {
        case 'LARGE':
          return 4
        default:
          return 12
      }
    },
    getMdText() {
      switch (this.getSize) {
        case 'LARGE':
          return 8
        default:
          return 12
      }
    },
    getBackgroundColor() {
      return this.category.backgroundColor ? this.category.backgroundColor : null
    },
    getBorder() {
      return this.category.borderColor ? 'solid 2px ' + this.category.borderColor : null
    },
    getFontColor() {
      return this.category.fontColor ? this.category.fontColor : null
    },
    getIconColor() {
      return this.category.iconColor ? this.category.iconColor : null
    },
    getIcon() {
      return this.category.icon ? this.category.icon : null
    }
  },
  methods: {
    addProduct(product, category, order) {
      if (this.quantity < this.stockQuantity) {
        this.$store.commit('addItem', {product, category, order})
      }
    },
    removeProduct(product, category) {
      this.$store.commit('removeItem', {product, category})
    },
  }
}
</script>

<style scoped>
.semiTransparent{
  opacity: 0.5;
}
</style>
